var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['mars3d-container', _vm.customClass, { 'mars3d-container-compare-rh' : _vm.compare }],attrs:{"id":`mars3d-container${_vm.mapKey}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }